import { en } from './en';
import { de } from './de';
import { en as enCourses } from './en-courses';
import { de as deCourses } from './de-courses';

const translations = {
  en,
  de,
  'en-courses': enCourses,
  'de-courses': deCourses,
};

// Cache for user overrides
let userOverridesCache = null;
let overridesCacheLanguage = null;

// Function to get nested value from object using dot notation
const getNestedValue = (obj, path) => {
  // First try direct key access (for flat overrides like {"checkout.title": "value"})
  if (obj && obj[path] !== undefined) {
    return obj[path];
  }

  // Fall back to nested access (for nested objects like {checkout: {title: "value"}})
  const keys = path.split('.');
  let value = obj;
  for (const k of keys) {
    value = value?.[k];
  }
  return value;
};

export const getTranslation = (key, params = {}) => {
  const language = localStorage.getItem('ticketing_language') || 'en';

  // Check if we have cached overrides for this language
  if (userOverridesCache && overridesCacheLanguage === language) {
    const overrideValue = getNestedValue(userOverridesCache, key);
    if (overrideValue !== undefined && overrideValue !== null) {
      if (typeof overrideValue === 'string') {
        return overrideValue.replace(/{(\w+)}/g, (match, param) => params[param] != null ? String(params[param]) : match);
      }
      return overrideValue;
    }
  }

  // Fall back to default translations
  const keys = key.split('.');
  let value = translations[language];

  for (const k of keys) {
    value = value?.[k];
  }

  if (typeof value === 'string') {
    return value.replace(/{(\w+)}/g, (match, param) => params[param] != null ? String(params[param]) : match);
  }

  return value || key;
};

export const t = getTranslation;

export const setLanguage = (lang) => {
  localStorage.setItem('ticketing_language', lang);
};

export const getCurrentLanguage = () => {
  return localStorage.getItem('ticketing_language') || 'en';
};

export const setUserOverrides = (overrides, language) => {
  userOverridesCache = overrides;
  overridesCacheLanguage = language;
};

export const clearUserOverrides = () => {
  userOverridesCache = null;
  overridesCacheLanguage = null;
};

export const getUserOverrides = () => {
  return userOverridesCache;
};
